module.exports = __webpack_public_path__ + "static/home-work-5ccd9922071e538dc6c1cfd7fc517846.jpg";